<div class="mobi-ui-grid is-centered !pt-[110px] md:!pt-[130px]">
  <div
    class="mobi-ui-col-1/1 md:mobi-ui-col-3/4 !pb-[130px] md:!pb-[160px] mobi-ui-section-minor mobi-ui-section-illustration-wrapper-minor is-large !mt-0"
  >
    @if (!settings.confirmation_image) {
      <mobi-ui-illustration-major
        class="mobi-ui-section-illustration-minor"
        [illustration]="{ name: 'house', symbol: 'basic_house' }"
      />
    }
    @if (settings.confirmation_image) {
      <img
        class="mobi-ui-section-illustration-minor"
        [src]="settings.confirmation_image"
        alt="confirmation page illustration"
      />
    }
    @if (settings.confirmation_title) {
      <h2 class="mobi-ui-text-center">
        {{ settings.confirmation_title }}
      </h2>
    }
    @if (settings.confirmation_lead) {
      <p
        class="mobi-ui-text-center mobi-ui-text-inked mobi-ui-font-tisa mobi-ui-font-size-150"
      >
        {{ settings.confirmation_lead }}
      </p>
    }
    @if (settings.confirmation_message) {
      <p class="mobi-ui-text-center mobi-ui-font-size-150">
        {{ settings.confirmation_message }}
      </p>
    }
  </div>
</div>
@if (hasNextSteps) {
  <section class="mobi-ui-grid is-centered !pb-20 md:pb-0">
    <div
      class="mobi-ui-col-1/1 md:mobi-ui-col-3/4 mobi-ui-section-minor mobi-ui-section-icon-wrapper-minor is-centered mobi-ui-ink-default"
    >
      <mobi-ui-icon-major
        class="relative z-10 mobi-ui-section-icon-minor mobi-ui-ink-blue mobi-ui-text-inked"
        size="xxl"
        name="inkable_signpost"
      />
      <div class="relative z-[1] mobi-ui-ink-blue">
        @if (settings.confirmation_steps_title) {
          <h3
            class="mobi-ui-text-center mobi-ui-font-h4 mobi-ui-padding-t-xxs mobi-ui-text-inked"
          >
            {{ settings.confirmation_steps_title }}
          </h3>
        }
        @if (settings.confirmation_steps_lead) {
          <p class="mobi-ui-text-center">
            {{ settings.confirmation_steps_lead }}
          </p>
        }
        @if (settings.confirmation_steps?.length) {
          <ul class="mobi-ui-timeline-major">
            @for (step of settings.confirmation_steps; track step) {
              <li class="mobi-ui-timeline-item-major">
                <div class="mobi-ui-timeline-icon-major">
                  <mobi-ui-icon-major [name]="step.icon || 'shield_tik'" class="md" />
                </div>
                @if (step.title) {
                  <div class="mobi-ui-timeline-content-major mobi-ui-font-100">
                    <div class="mobi-ui-card-minor">
                      <p>{{ step.title }}</p>
                    </div>
                    @if (step.show_pdf && settings.pdf_blob) {
                      <button
                        (click)="download()"
                        class="mobi-ui-card-major mobi-ui-margin-t-sm"
                      >
                        <div class="mobi-ui-text-block-major is-small">
                          <mobi-ui-icon-major name="document" />
                          <div class="mobi-ui-text-block-content-major">
                            <span class="mobi-ui-text-block-label-major">
                              {{
                                'police'
                                  | texts: { context: 'primcalc', default: 'Police' }
                              }}
                            </span>
                            <span class="mobi-ui-text-block-body">
                              {{
                                'insurance_document'
                                  | texts
                                    : {
                                        context: 'primcalc',
                                        default: 'Mein Versicherungsdokument',
                                      }
                              }}
                            </span>
                          </div>
                        </div>
                      </button>
                    }
                  </div>
                }
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </section>
}
@if (settings.confirmation_show_my_mobi) {
  <section class="mobi-ui-grid is-centered">
    <div
      class="mobi-ui-col-1/1 md:mobi-ui-col-3/4 !pt-[130px] md:!pt-[160px] flex items-start mobi-ui-section-minor is-large"
    >
      <div class="mobi-ui-timeline-item-major">
        <mobi-ui-icon-inkable-major
          class="pr-[15px] -translate-y-1/4"
          size="lg"
          name="inkable_my_mobiliar"
        ></mobi-ui-icon-inkable-major>
        <div class="">
          <h3 class="mobi-ui-font-h4 !pt-0 mobi-ui-text-inked">
            {{
              'my_mobi_title'
                | texts: { context: 'primcalc', default: '«Meine Mobiliar»' }
            }}
          </h3>
          <p>
            {{
              'my_mobi_lead'
                | texts
                  : {
                      context: 'primcalc',
                      default:
                        'Das «Meine Mobiliar» Kundenportal bietet Ihnen jederzeit und papierlos einen Überblick auf Ihre Versicherungsdokumente. Mit wenigen Klicks verfolgen Sie den Schadenstatus, kontaktieren Ihre Beraterin oder Ihren Berater oder beantragen eine Vollmacht.',
                    }
            }}
          </p>
          <ul class="mobi-ui-list-silent is-block mobi-ui-margin-t-sm">
            <li>
              <a
                class="mobi-ui-link-block-major"
                target="_blank"
                href="https://b2cidp.mobiliar.ch/b2c-login-registration/registration"
              >
                <mobi-ui-icon-major class="mobi-ui-link-block-icon-major" name="right" />
                <span class="mobi-ui-link-block-text-major">
                  {{
                    'my_mobi_register'
                      | texts
                        : {
                            context: 'primcalc',
                            default: 'Jetzt registrieren',
                          }
                  }}
                </span>
              </a>
            </li>
            <li>
              <a
                class="mobi-ui-link-block-major"
                target="_blank"
                href="https://b2cidp.mobiliar.ch/b2c-login-registration/login"
              >
                <mobi-ui-icon-major class="mobi-ui-link-block-icon-major" name="right" />
                <span class="mobi-ui-link-block-text-major">
                  {{
                    'my_mobi_login'
                      | texts: { context: 'primcalc', default: 'Jetzt anmelden' }
                  }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
}
@if (teasers?.length) {
  <section
    class="confirmation-background mobi-ui-section-minor mobi-ui-section-icon-wrapper-minor is-centered mobi-ui-ink-default"
    [class]="{
      '!pb-[6.5rem]': settings.confirmation_show_contact,
      'lg:!pb-0': settings.confirmation_show_contact,
    }"
  >
    <div class="mobi-ui-ink-blue mobi-ui-padding-b-lg">
      @if (settings.confirmation_teasers_title) {
        <h2 class="mobi-ui-centered">
          {{ settings.confirmation_teasers_title }}
        </h2>
      }
      @if (settings.confirmation_teasers_lead) {
        <p
          class="mobi-ui-margin-b-xl mobi-ui-margin-t-sm mobi-ui-centered mobi-ui-font-size-150"
        >
          {{ settings.confirmation_teasers_lead }}
        </p>
      }
      <mobi-teaser-list [teasers]="teasers" />
    </div>
  </section>
}
<section class="py-12 lg:py-5">
  @if (settings.confirmation_show_contact) {
    <webform-gabox
      class="block"
      [title]="settings.confirmation_contact_title"
      [lead]="settings.confirmation_contact_lead"
      [contact]="{
        title: settings.confirmation_contact_button_title,
        url: settings.confirmation_contact_button_link,
      }"
    ></webform-gabox>
  }
</section>
